import { gql } from '@apollo/client'

export default gql(`
    mutation deleteOfferAttribute($id: ID!, $partnerId: ID, $name: String, $type: OfferInputTypes $project: String) {
        deleteOfferAttribute(
            id: $id 
            partnerId: $partnerId
            name: $name
            type: $type
            project: $project
        ) {
            id
        }
    }`
)
